/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {SimpleModalHolderComponent as ɵa} from './simple-modal/simple-modal-holder.component';
export {SimpleModalServiceFactory as ɵc} from './simple-modal/simple-modal-service.factory';
export {SimpleModalWrapperComponent as ɵb} from './simple-modal/simple-modal-wrapper.component';